export default class ProfitCalculator {
    
    constructor() {

        this.registerEvents();

        this.v = {};

    }

    getDataPeriodDurationInHours(measurement, duration) {

        switch(measurement)
        {
            case 'hours':
                return duration;
                break;

            case 'minutes':
            default:
                return (+duration / 60);
                break;
        }

    }


    /*--- get form values ------------------------------------------------------*/


    getFormValues() {

        return {

            'totalHours': +this.getDataPeriodDurationInHours(document.getElementById('total-hours-measure').value, document.getElementById('total-hours').value),
            'profitPerPart': document.getElementById('profit-per-part').value,
            'partsPerHour': document.getElementById('parts-per-hour').value,
            'timePeriod': document.getElementById('time-period').value,

            // 'availability': document.getElementById('availability').value,
            // 'performance': document.getElementById('performance').value,
            // 'quality': document.getElementById('quality').value

       };
 
    }


    /*--- update projection ------------------------------------------------------*/


    updateProjection(v, oeeIncrease, timePeriod) {
        
        const parts100 = v.totalHours * v.partsPerHour;
        const profit100 = parts100 * v.profitPerPart;
        const parts1 = parts100 / 100;
        const profit1 = profit100 / 100;

        document.querySelector('[data-100-parts]').innerHTML = parts100.toLocaleString();
        document.querySelector('[data-100-profit]').innerHTML = profit100.toLocaleString();
        document.querySelector('[data-1-parts]').innerHTML = parts1.toLocaleString();
        document.querySelector('[data-1-profit]').innerHTML = profit1.toLocaleString();
        
        document.getElementById('daily-projection').value = (profit1 * oeeIncrease).toLocaleString();
        document.getElementById('future-projection').value = ((profit1 * oeeIncrease) * timePeriod).toLocaleString();

    }


    /*--- events ------------------------------------------------------*/


    registerEvents() {
                
        // event: change form
        ['change', 'keyup'].forEach(eventType => {

            document.getElementById('profit-data-form').addEventListener(eventType, e => {

                e.preventDefault();
                
                // get form values
                const v = this.getFormValues();

                // calculate & update projections
                if(v.totalHours > 0 && v.profitPerPart > 0 && v.partsPerHour > 0)
                {
                    const oeeIncrease = document.getElementById('oee-increase').value;
                    const timePeriod = document.getElementById('time-period').value;
    
                    this.updateProjection(v, oeeIncrease, timePeriod);
                }
    
            });

        });
                
    }

}
